<template>
  <div
    class="deck-list-row row"
    @click="rowClick"
  >
    <div
      v-if="thumbnail"
      class="thumbnail thumbnail-img"
      role="img"
      :aria-label="`Media for ${name}`"
      :style="{ backgroundImage: thumbnail }"
    />
    <div
      v-else
      class="thumbnail"
    />
    <div class="name">
      {{ name }}<span><span>-</span>{{ metadata }}</span>
    </div>
    <div class="action-container">
      <icon
        name="arrow"
        class="arrow"
        variant="4fb9de"
      />
    </div>
  </div>
</template>

<script>
import Icon from '@components/singletons/icon';

export default {
  name: 'DeckListRow',
  components: { Icon },
  props: {
    deck: {
      type: Object,
    },
  },
  computed: {
    metadata() {
      if (this.deck) {
        return this.deck.cardMetadata(this.$store);
      }
    },
    name() {
      if (this.deck) {
        return this.deck.assetTitle;
      }
    },
    thumbnail() {
      if (this.deck) {
        const url = this.$store.getters['attachments/get'][this.deck.displayAttachmentId];
        if (url) {
          return `url("${url}")`;
        }
      }
    },
  },
  methods: {
    rowClick() {
      this.$emit('row-clicked', this.deck);
    },
  },
};
</script>

<style lang="scss" scoped>
.deck-list-row {
  padding-left: 4rem;
}
.row {
  background-color: inherit;
  font-weight: $semi-bold;
  cursor: pointer;

  .name {
    display: flex;
    flex: 1;
    align-items: center;
    margin-left: rem-calc(24);
    color: #000000;
    font-size: rem-calc(14);

    span {
      color: #6c747a;
      font-size: rem-calc(12);

      span {
        margin: 0 rem-calc(8);
      }
    }
  }
  .thumbnail {
    width: 70px;
    height: 39px;
    background-color: #ebedef;
    display: flex;
    align-items: center;
    justify-content: center;

    &.thumbnail-img {
      background-position: center;
      background-size: cover;
    }
  }
  .action-container {
    display: flex;
    align-items: center;
    flex-direction: row;
    min-width: rem-calc(60);

    @include breakpoint(small) {
      flex-direction: column-reverse;
      min-width: rem-calc(40);
    }

    .arrow {
      margin-left: auto;

      @include breakpoint(small) {
        margin-left: 0;
      }
    }
  }
}
</style>
